import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import useAxiosPrivate from "../hooks/useAxiosPrivate";
import MainLoader from "../components/MainLoader";
import useAuth from '../hooks/useAuth';

export default function ImpersonateRedirect() {
  const { auth, setAuth, setShowLoader } = useAuth();

  const axios = useAxiosPrivate();
  const location = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    verifyAndRedirect()
  }, []);

  const verifyAndRedirect = async () => {
    
    setShowLoader(true);
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const expires_at = params.get("expires_at");

    if (auth.user) {
      window.location.href = "/"
    }

    if (!token) {
      console.error("No Token")
      window.location.href = "/"
    }

    localStorage.setItem("token", token);
    localStorage.setItem("impersonating", "true");
    localStorage.setItem("impersonation_expire", expires_at);

    try {
      const response = await axios.get(`/impersonate-login?token=${token}&expires_at=${expires_at}`)
      setAuth({ user: response.data.user, token: token, schools: response.data.schools })

      if (response.data.schools && response.data.schools.length === 0) {
        console.error("No Schools for this contact found")
        window.location.href = "/"
      }

      if (response.data.schools.length > 1) {
        navigate('/account-select')
      } else {
        navigate('/dashboard')
      }
    } catch (err) {
      console.error("Failed to login impersonated user", err)
      window.location.href = "/"
    } finally {
      setShowLoader(false);
    }
  }

  return <MainLoader />
}


